<main class="min-h-[100lvh] bg-slate-50">
    <router-outlet></router-outlet>
</main>